import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const ProfileSettings = () => {
  const { user, setUser } = useAuth();
  const toast = useToast();

  const [name, setName] = useState(user?.name || '');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) return setError('Name is required');
    if (password && password.length < 6) return setError('Password must be at least 6 characters');
    if (password && password !== confirm) return setError('Passwords do not match');

    setSaving(true);
    try {
      const payload = { name: name.trim() };
      if (password) payload.password = password;
      const res = await axios.patch('/api/auth/profile', payload);
      setUser(res.data);
      toast.success('Profile updated');
      setPassword('');
      setConfirm('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="main-content">
      <div className="page-header">
        <div>
          <h1 className="page-title">Profile Settings</h1>
          <p className="page-subtitle">Update your name and password</p>
        </div>
      </div>

      <div className="card" style={{ maxWidth: '560px' }}>
        <div className="card-body">
          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Employee ID</label>
              <input type="text" className="form-input" value={user?.employeeId || '—'} disabled style={{ background: 'var(--gray-100)' }} />
              <div className="form-hint">Employee ID cannot be changed</div>
            </div>

            <div className="form-group">
              <label className="form-label">Email</label>
              <input type="text" className="form-input" value={user?.email || ''} disabled style={{ background: 'var(--gray-100)' }} />
            </div>

            <div className="form-group">
              <label className="form-label">Name *</label>
              <input type="text" className="form-input" value={name} onChange={(e) => { setName(e.target.value); setError(''); }} />
            </div>

            <div className="form-group">
              <label className="form-label">New Password</label>
              <input type="password" className="form-input" placeholder="Leave blank to keep current password" value={password} onChange={(e) => { setPassword(e.target.value); setError(''); }} autoComplete="new-password" />
            </div>

            <div className="form-group">
              <label className="form-label">Confirm New Password</label>
              <input type="password" className="form-input" placeholder="Re-enter new password" value={confirm} onChange={(e) => { setConfirm(e.target.value); setError(''); }} autoComplete="new-password" />
            </div>

            <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;
